// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3XaMW","right":"Footer_right__3zzE5","buttons":"Footer_buttons__1NWMG"};